import * as React from 'react';
import { SVGProps } from 'react';

const IcCritical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <rect width={24} height={24} x={0.667} fill="#FCCFCD" rx={12} />
    <path
      fill="#B95A53"
      fillRule="evenodd"
      d="M12.667 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-13a1 1 0 0 0-.993.883L11.667 8v4a1 1 0 0 0 1.993.117l.007-.117V8a1 1 0 0 0-1-1Zm0 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default IcCritical;
